import { Loading } from 'element-ui'
import { Notification } from 'element-ui'

let loadingComponent

export function openLoadingMask() {
  loadingComponent = Loading.service({
    lock: false,
    text: 'loading...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

export function closeLoadingMask() {
  loadingComponent.close()
}

export function notify(message, type = 'error', { duration = 2000 } = {}) {
  Notification({
    message,
    type,
    duration
  })
}
